import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../system/icons';
import { TONE } from '../system/tone';
export function IconTile({ tone = 'neutral', size = 36, shape = 'rounded', selected, children, style, }) {
    const t = TONE[tone];
    const bg = selected ? t.ink : t.bg;
    const fg = selected ? 'var(--background)' : t.ink;
    return (_jsx("div", { style: {
            width: size, height: size,
            borderRadius: shape === 'circle' ? 'var(--radius-full)' : 'var(--radius-md)',
            background: bg, color: fg,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
            ...style,
        }, children: _jsx(Icon, { size: Math.round(size * 0.5), children: children }) }));
}
//# sourceMappingURL=IconTile.js.map